// Core methods for making API requests

// Function to make a POST request
function Post(data, URL, callback) {
  try {
    PaymentLoader(true); // Show loading spinner
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
        PaymentLoader(false); // Hide loading spinner
        callback(xmlHttp.response);
      } else if (xmlHttp.readyState == 4 && xmlHttp.status == 422) {
        PaymentLoader(false);
        callback(xmlHttp.response);
      } else if (xmlHttp.readyState == 4 && xmlHttp.status == 500) {
        PaymentLoader(false);
        callback(xmlHttp.response);
      }
    };
    xmlHttp.open("post", URL);
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      if (!currentUser.guest_access_allowed)
        xmlHttp.setRequestHeader("Authorization", "Bearer " + currentUser.token);
    }
    xmlHttp.setRequestHeader("Accept", "application/json");
    xmlHttp.setRequestHeader("Content-Type", "application/json");
    xmlHttp.setRequestHeader("Access-Control-Allow-Headers", "*")
    xmlHttp.setRequestHeader("Access-control-Allow-Origin", "*");
    xmlHttp.send(JSON.stringify(data));
  } catch (er) {
    alert(er);
  } finally {
    setTimeout(() => {
      PaymentLoader(false); // Hide loading spinner in case of errors
    }, 5000);
  }
}

// Function to make a GET request
function Get(URL, callback) {
  try {
    PaymentLoader(true); // Show loading spinner
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
        PaymentLoader(false); // Hide loading spinner
        callback(xmlHttp.responseText);
      } else if (xmlHttp.readyState == 4 && xmlHttp.status == 422) {
        PaymentLoader(false);
        callback(xmlHttp.responseText);
      } else if (xmlHttp.readyState == 4 && xmlHttp.status == 500) {
        PaymentLoader(false);
        callback(xmlHttp.responseText);
      }
    };
    xmlHttp.open("GET", URL, true);
    xmlHttp.setRequestHeader("Access-control-Allow-Origin", "*");
    xmlHttp.send(null);
  } catch (er) {
    alert(er);
  } finally {
    setTimeout(() => {
      PaymentLoader(false); // Hide loading spinner in case of errors
    }, 5000);
  }
}

// Function to toggle the payment loader
function PaymentLoader(IsLoader) {
  if (IsLoader) {
    document.getElementById("loader").style.display = "block";
  } else {
    document.getElementById("loader").style.display = "none";
  }
}

// Function to format the API response
function ResponseFormat(response, callback) {
  var item = JSON.parse(response);
  if (item.success) {
    callback(item.success);
  } else if (item.error) {
    callback(item.error);
  } else {
    callback(response);
  }
}
